export const SITE = {
  name: "Simple Background Remover",
  company: "Hildreth Technologies LLC",
  email: "support@hildrethtechnology.com",
  location: "Florida, United States",
  effectiveDate: "July 16, 2026",
  year: "2026",
  url: "https://5f71b8a9-7f0d-44f3-968e-13a8b634c3be.preview.emergentagent.com",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Data Deletion", to: "/data-deletion" },
  { label: "Support", to: "/support" },
  { label: "Terms of Use", to: "/terms" },
];
